import React from 'react';
import { TableCell, TableRow, TableHead, TableSortLabel, Checkbox } from '@mui/material';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export const TableHeader = ({ 
    headings = [], 
    onRequestSort, 
    onClickGridCheckBox, 
    checkedHeaderCheckBox = false, 
    checkboxEnable = false, 
    hasData = false 
}) => {
    if (!Array.isArray(headings) || headings.length === 0) {
        return null;
    }
    
    const createSortHandler = (e, name) => {
        if (onRequestSort) {
            onRequestSort(e, name);
        }
    };

    // 1. DYNAMIC CHECK: Determine if a checkbox column actually exists in this table view
    const hasCheckboxColumn = headings.some(
        (col) => col && !col.hideValue && (col.type === 'checkbox' || col.name === 'checkbox')
    );

    return (
        <TableHead>
            <TableRow>
                {headings
                    .filter((column) => column && !column.hideValue)
                    .map((column) => {
                        const isSorted = column.initialOrdering === true ? false : true;
                        
                        let SortIcon = UnfoldMoreIcon;
                        if (isSorted) {
                            SortIcon = column.orderType === '-' ? KeyboardArrowDownIcon : KeyboardArrowUpIcon;
                        }

                        const isCheckboxCol = column.type === 'checkbox' || column.name === 'checkbox';
                        const isClaimIdCol = column.type === 'claim_stage_id' || column.name?.toLowerCase().includes('claim id');
                        const isActionCol = column.name?.toLowerCase() === 'action' || 
                                           column.name?.toLowerCase() === 'actions' || 
                                           column.name?.toLowerCase() === 'mywork_action';

                        // Default alignment is 'left', unless column.align is explicitly passed, or column is a checkbox
                        const cellAlignment = column.align || (column.type?.toLowerCase() === 'checkbox' ? 'center' : 'left');

                        return (
                            <TableCell
                                key={column.name}
                                align={cellAlignment}
                                sortDirection={!isSorted ? true : false}
                                sx={{
                                    backgroundColor: '#F3F4F6', // Keep top header background consistent
                                    ...(isCheckboxCol && {
                                        position: 'sticky',
                                        left: 0,
                                        zIndex: 4,
                                        minWidth: '60px',
                                        width: '60px',
                                    }),
                                    ...(isClaimIdCol && {
                                        position: 'sticky',
                                        left: hasCheckboxColumn ? '60px' : 0, // Offset to sit right next to the checkbox
                                        zIndex: 4,
                                    }),
                                    ...(isActionCol && {
                                        position: 'sticky',
                                        right: 0,
                                        zIndex: 3,
                                    })
                                }}
                            >
                                {column.type === 'checkbox' ? (
                                    <Checkbox
                                        checked={checkedHeaderCheckBox}
                                        onChange={(e) => onClickGridCheckBox(e, 'header')}
                                        inputProps={{ 'aria-label': 'select all items' }}
                                        disabled={checkboxEnable}
                                        size='small'
                                    />
                                ) : (column.sort && hasData) ? (
                                    <TableSortLabel
                                        active={column.sort}
                                        direction={!isSorted && column.orderType === '-' ? 'asc' : 'desc'}
                                        onClick={(e) => createSortHandler(e, column.name)}
                                        IconComponent={SortIcon}
                                    >
                                        {column.name}
                                    </TableSortLabel>
                                ) : (
                                    column.name
                                )}
                            </TableCell>
                        );
                    })}
            </TableRow>
        </TableHead>
    );
};